import apartmentSvg from '../../assets/icons/categories/apartment.svg';
import hotelsSvg from '../../assets/icons/categories/hotels.svg';
import restaurantSvg from '../../assets/icons/categories/restaurant.svg';
import locationSvg from '../../assets/icons/location.svg';
// import bankSvg from "../../assets/icons/categories/bank.svg";
import estaleSvg from '../../assets/icons/categories/estale.svg';

export const rating = {
  1: '1',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
};

export const category: { [key in string]: string } = {
  apartments: 'apartment',
  hotels: 'hotel',
  restaurants: 'restaurant',
  constructors: 'constructors',
};

export const iconsList: { [key in string]: any } = {
  apartments: apartmentSvg,
  hotels: hotelsSvg,
  restaurants: restaurantSvg,
  locations: locationSvg,
};

export const copiaCategories = [
  {
    title: 'constructors',
    img: estaleSvg,
    name: 'Real Estate',
  },
  {
    title: 'apartments',
    img: apartmentSvg,
    name: 'Apartments',
  },
  {
    title: 'hotels',
    img: hotelsSvg,
    name: 'Hotels',
  },
  {
    title: 'restaurants',
    img: restaurantSvg,
    name: 'Restaurants',
  },
];
